
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MRPDialog extends Serenity.EntityDialog<MRPRow, any> {
        protected getFormKey() { return MRPForm.formKey; }
        protected getIdProperty() { return MRPRow.idProperty; }
        protected getLocalTextPrefix() { return MRPRow.localTextPrefix; }
        protected getService() { return MRPService.baseUrl; }
        protected getDeletePermission() { return MRPRow.deletePermission; }
        protected getInsertPermission() { return MRPRow.insertPermission; }
        protected getUpdatePermission() { return MRPRow.updatePermission; }

        protected form = new MRPForm(this.idPrefix);

    }
}